import {Directive, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {PageLayoutService} from '../../../../../../../services/menu/page-layout.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[menuAction]',
})
export class MenuActionDirective implements OnInit, OnDestroy {
  private _caption: string;
  @Output() action = new EventEmitter();

  @Input() set caption(value: string) {
    if (value != this._caption) {
      this._caption = value;
      this.pageLayoutService.updateMenu();
    }
  }
  @Input() enabled: boolean;

  /** Item grisé et inactif dans le menu (ex. traitement en cours). */
  private _disabled = false;
  @Input() set disabled(value: boolean) {
    const disabled = value === true;
    if (disabled !== this._disabled) {
      this._disabled = disabled;
      this.pageLayoutService.updateMenu();
    }
  }
  get disabled(): boolean {
    return this._disabled;
  }

  get caption() {
    return this._caption;
  }
  constructor(private pageLayoutService: PageLayoutService) {}

  ngOnInit() {
    this.pageLayoutService.addMenuAction(this);
  }
  ngOnDestroy() {
    this.pageLayoutService.removeMenuAction(this);
  }
}
